import { useColumns } from '~/modules/common/components/ListTable';
import { buildColumns } from './columns';
import { getFormatters } from './formatters';

export const useListColumns = props =>
  useColumns({
    columns: buildColumns(props),
    renders: getFormatters(props)
  });
